import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {CdkDrag, CdkDragPlaceholder, CdkDragPreview} from '@angular/cdk/drag-drop';
import {DatePipe, NgClass} from '@angular/common';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {OrderStatusEnum} from '../../enums/status.enum';
import {AuthService} from '../auth/auth.service';
import { Order } from '../../classes/order.class';
import {MatTooltip} from '@angular/material/tooltip';
import { TimeZoneService } from '../../services/time-zone.service';

@Component({
    selector: 'app-task-card',
    standalone: true,
    imports: [
        CdkDrag,
        MatIconButton,
        MatIcon,
        DatePipe,
        NgClass,
        MatTooltip,
        CdkDragPreview,
        CdkDragPlaceholder,
    ],
    templateUrl: './task-card.component.html',
    styleUrl: './task-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskCardComponent {
  @Input({required: true}) task!: Order;
  @Input() smallWidth = false;
  @Input() executorList = false;
  @Input() selectedOrders: Set<Order> = new Set();
  @Output() taskInfo = new EventEmitter();
  @Output() isDrag = new EventEmitter();

  private startX = 0;
  private startY = 0;
  private isMouseDown = false; // Флаг для отслеживания состояния кнопки мыши
  private dragDistance = 5; // расстояние в px, после которого считаем что началось перетаскивание
  moveOrders = new Set<Order>();

  constructor(
      protected authService: AuthService,
      protected timeZoneService: TimeZoneService
  ) {}

  get totalDuration(): number {
      if (this.task.data.dropDuration) {
          return this.task.data.dropDuration;
      }

      return this.task.data.orderPrices.reduce((total, orderPrice) => {
          const duration = orderPrice?.price?.duration || 0;
          return total + (duration * (orderPrice.quantity || 0));
      }, 0);
  }

  dragStarted(): void {
      this.isDrag.emit(true);
  }

  onDragEnded(): void {
      this.onMouseUp();
  }

  // проброс наверх id задачи для открытия на новой странице
  showInfo(event: MouseEvent, id: number): void {
      event.stopPropagation();
      this.taskInfo.emit(id);
  }

  // обозначение цветом статуса заявки
  setStatusColor(status: string): string {
      switch (status) {
      case OrderStatusEnum.ready:
          return 'status_ready';
      case OrderStatusEnum.onway:
          return 'status_onway';
      case OrderStatusEnum.atwork:
          return 'status_atwork';
      case OrderStatusEnum.done:
          return 'status_done';
      case OrderStatusEnum.reject:
          return 'status_reject';
      case OrderStatusEnum.active:
          return 'status_active';
      }
      return 'status_destributed';
  }

  onLinkClick(event: Event): void {
      event.stopPropagation();
  }

  shortAddress(address: string): string {
      const parts = address.split(',');
      return parts.slice(2).join(',').trim();
  }

  // сообщаем что заявка готова к перетягиванию
  onMouseDown(event: MouseEvent): void {
      this.isMouseDown = true; // Устанавливаем флаг, что кнопка мыши зажата
      this.startX = event.clientX;
      this.startY = event.clientY;
  }

  // сообщаем что заявку перестали перетягивать
  onMouseUp(): void {
      this.isMouseDown = false; // Сбрасываем флаг, что кнопка мыши отпущена
      this.isDrag.emit(false);
  }

  onMouseMove(event: MouseEvent): void {
      if (!this.isMouseDown) {return;} // Если кнопка мыши не зажата, выходим из метода

      if (Math.abs(event.clientX - this.startX) > this.dragDistance || Math.abs(event.clientY - this.startY) > this.dragDistance) {
          if (this.task.data.executor?.id) {
              this.moveOrders = new Set([...this.selectedOrders].filter(order => order.data.executor?.id === this.task.data.executor?.id));
          } else {
              this.moveOrders = new Set([...this.selectedOrders].filter(order => !order.data.executor));
          }
          this.isDrag.emit(true);
      }
  }

}
